module.exports = __webpack_public_path__ + "static/media/location-934dcc.6048d7ba.svg";